/*
 *
 * TermsAndConditionsDetailPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Feb-2025
 */

import TermsAndConditionsDetailPopup from './TermsAndConditionsDetailPopupContainer'

export default TermsAndConditionsDetailPopup
